import { USER_INFO, VOUCHER_INFO } from "../common/constant";
import { IDelivery } from "../models/deliveryModel";
import { IVoucherInfo } from "../models/interface/IVoucherInfo";
import { IProfile } from "./../models/profileModel";

export const setLocalStorageUserInfo = (
  userInfo: IProfile,
  deliveryInfo: IDelivery[] | []
) => {
  const info = { ...userInfo, delivery_infos: deliveryInfo };
  delete info._id;
  delete info.id;
  delete info.identity_number;

  localStorage.setItem(USER_INFO, JSON.stringify(info));
};

export const getFirstWordName = (fullName: string) => {
  if (fullName) {
    return (
      fullName.split(" ")[0][0] +
      fullName.split(" ")[fullName.split(" ").length - 1][0]
    );
  }
  return "";
};

export const getVoucherCode = () => {
  const voucherInfo = localStorage.getItem(VOUCHER_INFO);

  if (!voucherInfo) return null;
  return JSON.parse(voucherInfo)?.code;
};

export const getVoucherInfo = () => {
  const voucherInfo = localStorage.getItem(VOUCHER_INFO);

  if (!voucherInfo) return null;
  return JSON.parse(voucherInfo);
};

export const setVoucherInfo = (voucherInfo: IVoucherInfo) => {
  localStorage.setItem(VOUCHER_INFO, JSON.stringify(voucherInfo));
};

export const clearVoucherInfo = () => {
  localStorage.removeItem(VOUCHER_INFO);
};
